
import React from 'react';


const TermsConditions = () => {
	return (
        <>
        <div className='w-11/12 lg:w-8/12 py-16 mx-auto space-y-10'>
            <h1 className='text-4xl font-bold text-center '>Terms and Conditions</h1>

            <div>
                <label>
                Terms and Conditions:
                </label>
                <label>
                AUSTRALIAN BOLLARDS ABN: 23 960 558 830
                </label>
                <label>
                 ** Product can be subject to change without Notice.
                </label>
                <label>
                *** All our Bollards comes with Australian Bollards Stainless Steel Cap & all our products are also marked with Australian Bollards product identification plate.
                </label>
            </div>
            
            <div className='space-y-4'>
                <h2 className='text-base font-bold'>
                1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Definitions and interpretation:
                </h2>
                <div className='flex flex-col pl-10 space-y-1'>
                    <label>
                        1.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Unless the context otherwise requires:
                    </label>
                    <label>
                    (a) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Agreement” means these terms and conditions of supply, any attached Schedule, the Express Warranty and the Order Form.
                    </label>
                    <label>
                    (b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; “Express Warranty” means the warranty published in the Supplier’s product catalogue current at the time of this Agreement.

                    </label>
                    <label>
                    (c) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“GST” means the goods and services tax provided for in the A New Tax System (Goods and Services Tax) Act 1999 (Cth).
                    </label>
                    <label>
                    (d) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Order” means an order for products from the Supplier.
                    </label>
                    <label>
                    (e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Order Form” means the form completed to order product to be supplied under this Agreement
                    </label>
                    <label>
                    (f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Person” includes legal and natural persons, incorporated and unincorporated associations and bodies politic.
                    </label>
                    <label>
                    (g)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Prescribed Terms” means the terms, conditions and warranties implied by law.
                    </label>
                    <label>
                    (h)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Product” means goods and services supplied by the Supplier.
                    </label>
                    <label>
                    (i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Purchaser” means the person who places an Order for and/or acquires Products from the Supplier.
                    </label>
                    <label>
                    (j)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Schedule” means the schedule to these terms and conditions of Supply. 
                    </label>
                    <label>
                    (k)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Supplier” means Australian Handrails Pty Ltd ABN 23 960 558 830 trading as Australian Bollards ABN 23 960 558 830, of 53-55 Korong Road, Heidelberg West Victoria 3081.
                    </label>
                    <label>
                    (l)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“Supply” means the supply of Products.  
                    </label>
                    <label>
                    1.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The singular connotes the plural and vice-versa.
                    </label>
                </div>
                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Entire agreement:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        2.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This Agreement:
                        </label>
                        <label>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Governs the terms and conditions on which Products are Ordered by, and Supplied to, the Purchaser.
                        </label>
                        <label>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Supersedes and excludes all previous oral or written communications and representations made by the Supplier to the Purchaser relating to the supply of Products.
                        </label>
                    </div>
                </div>
                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Price:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        3.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The product price is set out in the Order Form and includes GST. 
                        </label>
                    </div>
                </div>
                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Orders:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The Products to be supplied under this Agreement are as ordered in the Order Form relating to this Agreement.
                        </label>
                        <label>
                        4.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The Purchaser authorizes the Supplier to complete any Order Form received from the Purchaser in incomplete form and agrees to be bound by the completed order form.
                        </label>
                        <label>
                        4.3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The Supplier will only have accepted an Order in whole or part on the earlier of it notifying the Purchaser of its acceptance or by full or partial supply of the ordered Products.
                        </label>
                        <label>
                        4.4 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The Supplier may, in its sole discretion, delay acceptance of or delivery under any Order and may adjust or cancel part or all of an Order and the Supplier will not be liable to the Purchaser for any such delay, adjustment or cancellation.
                        </label>
                        <label>
                        4.5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; An Order received from the Purchaser which has been accepted by the Supplier cannot be cancelled by the Purchaser without the Supplier’s prior written approval.
                        </label>
                        <label>
                        4.6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Returns Policy: Products are non-refundable and cannot be returned after they have been purchased.
                        </label>
                        <label>
                        4.7  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; All Concrete products are manufactured in Insitu.
                        </label>
                        <label>
                        4.8 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For goods manufactured from Stone. Natural stone is subjected to change.
                        </label>
                        <label>
                        4.9 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Product design are subjected to change where applicable.
                        </label>
                        <label>
                        4.10 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If a purchase order is cancelled Australian Bollards/Handrails reserves the right to invoice the customer for 20% of the total value of the purchase order.
                        </label>

                    </div>
                </div>

                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;          Delivery, shipment, risk allocation and grant of security interest:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        5.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The delivery date will be estimated at the time of the Order and may vary depending on available stock. The Supplier is not liable.
                        </label>
                        <label>
                        5.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Restocking. Restocking at discretion of NJM Group.
                        </label>
                    </div>
                </div>

                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;          Payments:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        6.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Unless credit facilities are established with Australian Bollards. and maintained prior to placement of an Order payment shall be cash prior to delivery.
                        </label>
                        <label>
                        6.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Where credit facilities are established Australian Bollards.may charge interest at 2% per annum above the ANZ Bank ‘base’ rate quoted from time to time on the outstanding amount calculated from the due date for payment to the date the account is paid in full.
                        </label>
                        <label>
                        6.3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Australian Bollards may stop the supply of Goods to the Purchaser if the Purchaser’s account is outstanding after the due date for payment or a predetermined credit limit has been reached.
                        </label>
                        <label>
                        6.4 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The full purchase price for Goods or Services shall become immediately due and payable if the Purchaser is insolvent.
                        </label>
                        <label>
                        6.5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Australian Bollards may, at its sole discretion, withdraw credit facilities at any time.
                        </label>
                        <label>
                        6.6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Liquidated damages do not apply.
                        </label>
                        <label>
                        6.7 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No refunds.
                        </label>
                        <label>
                        6.8 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No retention money shall be withheld unless prior agreement has been reached.
                        </label>
                        <label>
                        6.9 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Set off charges and back charges by the customer do not apply.
                        </label>
                    </div>
                </div>

                <div className='space-y-4'>
                    <h2 className='text-base font-bold'>
                    7 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;          Installations:
                    </h2>

                    <div className='flex flex-col pl-10 space-y-1'>
                        <label>
                        7.1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Australian Bollards may take and publish photos of any products sold and installed by the company.  
                        </label>
                        <label>
                        7.2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; All installation in concrete the warranty is only valid after 28 days of concrete curing.  
                        </label>
                    </div>
                </div>










                


            </div>
        </div>
        </>
	);
 };
 
 export default TermsConditions;